module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form_wrapper"
  }, [_c('step-status', {
    staticClass: "mt55",
    attrs: {
      "step": _vm.$route.meta.step
    }
  }), _vm._v(" "), _c(_vm.fillformStatus, {
    tag: "components",
    attrs: {
      "status": _vm.$route.query.status
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-04f5d201"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/main/fillform/fillform.vue
// module id = 815
// module chunks = 1